const ATLAS_ARTICLE_TYPES = new Set([
  'atlas_article',
  'atlas_profile',
  'atlas_research',
  'atlas_analysis',
]);

export function isAtlasArticleType(type?: string): boolean {
  return !!type && ATLAS_ARTICLE_TYPES.has(type);
}
